/* eslint-disable */
import React from "react";
import { useState } from "react";
import EndpointHitter from "../../../ui-components/endpoint-hitter/endpoint-hitter";

const NimbusCronJobsIndex = () => {
  const [response, setResponse] = useState(null);

  return (
    <div className="flex flex-row w-full h-full p-6 justify-end items-end">
      <div className="flex flex-col text-center gap-2 w-full p-4"></div>
      <pre
        className={`w-full h-full  rounded-lg flex flex-col items-start justify-center p-4
        dark:text-color-dark-text-primary text-color-text-primary 
        dark:bg-color-dark-background-secondary bg-color-background-secondary`}
      >
        {response}
      </pre>
    </div>
  );
};

export default NimbusCronJobsIndex;
